import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import BoxList from '@/components/structure/BoxList';
import Container from '@/components/structure/Container';
import { useBreakpoint } from '@/hooks/useBreakpoints';
import { itemsValueProposition } from './data';
export const ValueProposition = () => {
    const { isDesktop } = useBreakpoint();
    return (_jsx(_Fragment, { children: isDesktop ? (_jsx(Container, { children: _jsx(Box, { paddingVertical: "spacing.80", children: _jsx(BoxList, { items: itemsValueProposition }) }) })) : (_jsx(Box, { backgroundColor: "color.surface.constant.white.default", borderRadius: "radius.16", marginTop: "-spacing.16", position: "relative", zIndex: "zIndex.1", children: _jsx(Container, { children: _jsx(Box, { paddingVertical: "spacing.32", children: _jsx(BoxList, { items: itemsValueProposition }) }) }) })) }));
};
